import React, { Fragment, Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import { routes } from './Routes';
import Layout from '../Layout/Layout';
import ProtectedRoute from './ProtectRoute';
import SpinnerLoader from '../Layout/SpinnerLoader';

const LayoutRoutes = () => {

  return (
    <Fragment>
      <Routes>
        {routes.map(({ path, Component, protected: isProtected, requiredRole, requiredPermission, requiredPlanType, requiredPlanStatus,requireSubStatus }, i) => (
          <Route element={<Layout />} key={i}>
            <Route
              path={path}
              element={
                <Suspense fallback={<SpinnerLoader />}>
                  {(isProtected || requiredPermission || requireSubStatus) ? (
                    <ProtectedRoute
                      component={Component}
                      requiredRole={requiredRole}
                      requiredPermission={requiredPermission}
                      requiredPlanType={requiredPlanType}
                      requiredPlanStatus={requiredPlanStatus}
                      requireSubStatus={requireSubStatus}
                    />
                  ) : (
                    Component
                  )}
                </Suspense>
              }
            />
          </Route>
        ))}
      </Routes>
    </Fragment>
  );
};

export default LayoutRoutes;
